export default __webpack_public_path__ + "static/media/partialCorrect.b4853035.wav";